// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"fea9825a","455":"b9aac7d1"}[chunkId] + ".chunk.js";
};